import { render, staticRenderFns } from "./emp_modal.vue?vue&type=template&id=5dab23fe&"
import script from "./emp_modal.vue?vue&type=script&lang=js&"
export * from "./emp_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports